import { useState } from 'react';
import { apiFetch } from '../api';

function GoalsManager({ goalsData, onUpdate }) {
  const [person, setPerson] = useState('Tim');
  const [title, setTitle] = useState('');
  const [frequency, setFrequency] = useState('daily');

  async function addGoal(e) {
    e.preventDefault();
    if (!title.trim()) return;

    try {
      await apiFetch('/api/goals', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ person, title: title.trim(), frequency }),
      });
      setTitle('');
      onUpdate();
    } catch (err) {
      console.error('Failed to add goal:', err);
    }
  }

  async function deleteGoal(id) {
    try {
      await apiFetch(`/api/goals/${id}`, { method: 'DELETE' });
      onUpdate();
    } catch (err) {
      console.error('Failed to delete goal:', err);
    }
  }

  const timGoals = goalsData.goals.filter((g) => g.person === 'Tim');
  const emilioGoals = goalsData.goals.filter((g) => g.person === 'Emilio');

  return (
    <div className="goals-manager">
      <section className="card">
        <h2>Add New Goal</h2>
        <form onSubmit={addGoal} className="goal-form">
          <div className="form-row">
            <label>Person</label>
            <div className="toggle-group">
              <button
                type="button"
                className={`toggle-btn ${person === 'Tim' ? 'active' : ''}`}
                onClick={() => setPerson('Tim')}
              >
                Tim
              </button>
              <button
                type="button"
                className={`toggle-btn ${person === 'Emilio' ? 'active' : ''}`}
                onClick={() => setPerson('Emilio')}
              >
                Emilio
              </button>
            </div>
          </div>
          <div className="form-row">
            <label>Goal</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter a goal..."
              className="goal-input"
            />
          </div>
          <div className="form-row">
            <label>Frequency</label>
            <div className="toggle-group">
              <button
                type="button"
                className={`toggle-btn ${frequency === 'daily' ? 'active' : ''}`}
                onClick={() => setFrequency('daily')}
              >
                Daily
              </button>
              <button
                type="button"
                className={`toggle-btn ${frequency === 'weekly' ? 'active' : ''}`}
                onClick={() => setFrequency('weekly')}
              >
                Weekly
              </button>
            </div>
          </div>
          <button type="submit" className="submit-btn">
            Add Goal
          </button>
        </form>
      </section>

      <section className="card">
        <h2>Tim's Goals</h2>
        <GoalList goals={timGoals} onDelete={deleteGoal} />
      </section>

      <section className="card">
        <h2>Emilio's Goals</h2>
        <GoalList goals={emilioGoals} onDelete={deleteGoal} />
      </section>
    </div>
  );
}

function GoalList({ goals, onDelete }) {
  if (goals.length === 0) return <p className="empty">No goals yet</p>;

  return (
    <ul className="goal-list manage-list">
      {goals.map((goal) => (
        <li key={goal.id} className="goal-item">
          <span className="goal-title">{goal.title}</span>
          <span className="goal-freq">{goal.frequency}</span>
          <button className="delete-btn" onClick={() => onDelete(goal.id)}>
            Delete
          </button>
        </li>
      ))}
    </ul>
  );
}

export default GoalsManager;
